import React from 'react';
import BaseV2 from '../../layout/BaseV2';
import ShiftListV2 from '../../components/dashboard/ShiftListV2';
import InProgressList from '../../../components/dashboard/InProgressList';

export default function HomeV2() {
  return (
    <BaseV2>
      <ShiftListV2 />
      <div className="mt-4">
        <InProgressList title="Peritajes en curso" />
      </div>
    </BaseV2>
  );
}
